import { SearchableDropdown } from './SearchableDropdown';

interface AttractionDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function AttractionDropdown({
  value,
  onChange,
  placeholder = 'Select Attraction',
  className,
}: AttractionDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search attractions..."
      className={className}
      endpoint="attractions"
      emptyText="No attractions found."
    />
  );
}
